module.exports = __webpack_public_path__ + "static/media/logo_inmmo_blanco.9adaa79f.png";